/*
 * fn: scrollToAnchor
 *
 * Scroll an anchor into view, optionally only when it already sits near the top of the viewport
 *
 */
import { type ScrollAnchorType } from '@/defs/scroll'

type Props = {
  isSmooth?: boolean
} & ScrollAnchorType

export const scrollToAnchor = ({ id, ifNearTop, isSmooth }: Props) => {
  const el = document.getElementById(id)
  if (!el) return

  if (ifNearTop) {
    const offset = parseFloat(getComputedStyle(el).scrollMarginTop) || 0
    if (!el.getClientRects().length || el.getBoundingClientRect().top > offset + 50) return
  }

  el.scrollIntoView({ behavior: isSmooth ? 'smooth' : undefined })
}
